import React from 'react';

import { Box, useTheme } from '@mui/system';
import { BooleanBadge, useModal } from '@europrocurement/flexy-components';
import { Button } from '@mui/material';
import { GroupeTravailUtilisateurApiObject } from '@europrocurement/l2d-domain';
import { JointureUtilisateurGroupeTravailJsonldUserworkgroupRead as member } from '@europrocurement/l2d-domain/openApi/ApiUtilisateur';
import { WorkGroupUpdateMembersForm } from '../../../WorkGroupModals/WorkGroupUpdateMembers';

type MembersHeaderProps = {
    workgroup: GroupeTravailUtilisateurApiObject;
    historicInscription: boolean;
    setHistoricInscription: React.Dispatch<React.SetStateAction<boolean>>;
    isActiveStatus: boolean;
    members: member[];
};

export const MembersHeader: React.FunctionComponent<MembersHeaderProps> = function ({
    workgroup,
    historicInscription,
    setHistoricInscription,
    isActiveStatus,
    members,
}) {
    const { palette } = useTheme();
    const { modalActions } = useModal();

    // Update groupe travail référent modal.
    const handleModifyMembers = () => {
        modalActions.call(
            <WorkGroupUpdateMembersForm
                workgroup={workgroup}
                historicInscription={historicInscription}
                isActiveStatus={isActiveStatus}
                members={members}
            />,
        );
    };

    return (
        <Box
            className="heading"
            sx={{
                borderLeftColor: palette.primary.main,
            }}
        >
            <Box
                className="title"
                sx={{
                    color: palette.text.primary,
                }}
            >
                <div
                    style={{
                        display: 'flex',
                    }}
                >
                    Membres
                    <div
                        style={{
                            display: 'flex',
                            position: 'relative',
                            marginLeft: '7px',
                            bottom: '2px',
                        }}
                    >
                        {isActiveStatus ? (
                            <BooleanBadge
                                label="Actif"
                                value={!historicInscription}
                                icon
                                toggleAction={() => {
                                    setHistoricInscription(!historicInscription);
                                }}
                            />
                        ) : (
                            <BooleanBadge
                                label="Actif"
                                value={false}
                                icon
                            />
                        )}
                    </div>
                </div>
            </Box>

            <Button
                aria-label="display-update-members-modal-button"
                className="action"
                onClick={handleModifyMembers}
                sx={{
                    color: palette.primary.main,
                }}
            >
                Modifier
            </Button>

            <Box
                className="completion-feedback"
                sx={{
                    color: palette.text.primary,
                }}
            >
                {historicInscription
                    ? 'Inscriptions clôturées uniquement'
                    : 'Inscriptions actives uniquement'}
            </Box>
        </Box>
    );
};
